import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    persist_settings: false,
    viewInspector: false,
    polling: true,
    overrideAPI: "default",
    create_sso_users: false,
    run_sentry_localhost: false,
    useTestApiHeader: false,
    isStyle2pt0: true,
    showRealTimeAuths: false,
    showRevBoost_retry: false,
    showCredentialManagement_npt: false,
    showRevBoost_Experiments2: false
};

const reducers = {
    PERSIST_SETTINGS:
        (state, action) => ({ ...state, persist_settings: action.payload }),

    DEBUG_MODE:
        (state, action) => ({ ...state, viewInspector: action.payload }),

    POLLING:
        (state, action) => ({ ...state, polling: action.payload }),

    SET_API:
        (state, action) => ({ ...state, overrideAPI: action.payload }),

    CREATE_SSO_USERS:
        (state, action) => ({ ...state, create_sso_users: action.payload }),

    RUN_SENTRY_LOCALHOST:
        (state, action) => ({ ...state, run_sentry_localhost: action.payload }),

    SYNC_STATE: (state, { payload: newState }) => ({
        ...state,
        ...newState
    }),

    RESET_STATE: () => ({ ...initialState }),

    SET_TEST_API_HEADER:
    (state, action) => ({ ...state, useTestApiHeader: action.payload }),

    SET_STYLE2PT0:
        (state, action) => ({ ...state, isStyle2pt0: action.payload }),

    SET_SHOW_REAL_TIME_AUTHS:
        (state, action) => ({ ...state, showRealTimeAuths: action.payload }),

    SET_SHOW_REV_BOOST_RETRY:
        (state, action) => ({ ...state, showRevBoost_retry: action.payload }),

    SET_SHOW_CREDENTIAL_MANAGEMENT_NPT:
        (state, action) => ({ ...state, showCredentialManagement_npt: action.payload }),

    SET_SHOW_REV_BOOST_EXPERIMENTS2:
        (state, action) => ({ ...state, showRevBoost_Experiments2: action.payload }),

    SET_SHOW_INVOICES_PAGE:
        (state, action) => ({ ...state, showInvoicesPage: action.payload })

};

export const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers
});

export const settings = settingsSlice.reducer;
export const {
    PERSIST_SETTINGS,
    DEBUG_MODE,
    POLLING,
    SET_API,
    CREATE_SSO_USERS,
    RUN_SENTRY_LOCALHOST,
    SYNC_STATE,
    RESET_STATE,
    SET_TEST_API_HEADER,
    SET_SHOW_REAL_TIME_AUTHS,
    SET_STYLE2PT0,
    SET_SHOW_REV_BOOST_RETRY,
    SET_SHOW_REV_BOOST_EXPERIMENTS2,
    SET_SHOW_CREDENTIAL_MANAGEMENT_NPT,
    SET_SHOW_INVOICES_PAGE
} = settingsSlice.actions;
